// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3RK2f","colMin":"styles_colMin__346L7","colCheckbox":"styles_colCheckbox__1E3hD"};